export default "__VITE_ASSET__CCDEZj5y__"